// src/utils/api.ts
const BASE = "https://api.playbro.com";

// The internal game-asset origin (IP:port) is not publicly reachable on live,
// so its image URLs are routed through the playbro.com proxy (Apache
// /game-assets/ block). e.g.
//   http://187.77.119.195:8080/evolution-gaming/fan-tan/image.avif
//   -> https://playbro.com/game-assets/evolution-gaming/fan-tan/image.avif
const GAME_ASSET_ORIGIN = "187.77.119.195:8080";
const GAME_ASSET_PROXY = "https://playbro.com/game-assets";

export function resolveImageUrl(url?: string | null): string {
  if (!url) return "";
  const host = window.location.hostname;
  // Locally the IP:port host is reachable directly, so leave it untouched.
  if (host === "localhost" || host === "127.0.0.1") return url;
  const originRe = new RegExp(`^https?://${GAME_ASSET_ORIGIN.replace(/\./g, "\\.")}`, "i");
  const proxied = url.replace(originRe, GAME_ASSET_PROXY);
  return proxied.replace(/^http:\/\//i, "https://");
}

export async function apiFetch<T = any>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const token = localStorage.getItem("token");
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(options.headers as any),
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };

  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers
  });

  if (res.status === 401) {
    const errorData = await res.json().catch(() => ({}));
    if (errorData.code === 'TOKEN_EXPIRED') {
      // Show a nicer message to user
      console.log('Session expired, redirecting to login...');
    }
    localStorage.clear();
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }
  if (!res.ok) {
    const text = await res.text();
    const err = new Error(text || `Error ${res.status}`) as Error & { status?: number };
    err.status = res.status;
    throw err;
  }
  return (res.status === 204 ? ({} as T) : (await res.json())) as T;
}
